import {
  SPECIAL_EQUIPMENT_SUBTYPES,
} from "../vehicle/vehicleCatalog.js";

// REISOR_PHASE3A_PERFORMER_CATALOG_V2

export const PERFORMER_CATEGORIES = [
  "CARGO",
  "SPECIAL",
  "TOW",
  "PASSENGER",
];

export const CARGO_BODY_TYPES = [
  "Тент",
  "Фургон",
  "Рефрижератор",
  "Изотерм",
  "Контейнер",
  "Платформа/борт",
  "Mega",
  "Фура / паровоз",
  "Исузу",
  "Бонго",
  "Газель",
  "Лабо",
  "Самосвал",
  "Другое",
];

export const PASSENGER_ASSET_TYPES = [
  "CAR",
  "MINIVAN",
  "MICROBUS",
  "BUS",
];

export const PASSENGER_SERVICES = [
  "INTERCITY",
  "TRANSFER",
  "WEDDING",
];

export const SPECIAL_PERFORMER_SUBTYPES =
  SPECIAL_EQUIPMENT_SUBTYPES.filter(
    (value) => value !== "Эвакуатор"
  );

export function performerText(
  language,
  ru,
  uz,
  tr
) {
  const lang =
    String(language || "ru").toLowerCase();

  if (lang.startsWith("uz")) return uz;
  if (lang.startsWith("tr")) return tr;

  return ru;
}

export function performerCategoryLabel(
  value,
  language
) {
  const tx = (ru, uz, tr) =>
    performerText(language, ru, uz, tr);

  return {
    CARGO: tx("Грузовик", "Юк машинаси", "Kamyon"),
    SPECIAL: tx(
      "Спецтехника",
      "Махсус техника",
      "Özel ekipman"
    ),
    TOW: tx("Эвакуатор", "Эвакуатор", "Çekici"),
    PASSENGER: tx(
      "Пассажирский транспорт",
      "Йўловчи транспорти",
      "Yolcu taşımacılığı"
    ),
  }[value] || value;
}

export function passengerAssetLabel(
  value,
  language
) {
  const tx = (ru, uz, tr) =>
    performerText(language, ru, uz, tr);

  return {
    CAR: tx(
      "Легковая",
      "Енгил автомобиль",
      "Otomobil"
    ),
    MINIVAN: tx(
      "Минивэн",
      "Минивен",
      "Minivan"
    ),
    MICROBUS: tx(
      "Микроавтобус",
      "Микроавтобус",
      "Minibüs"
    ),
    BUS: tx(
      "Автобус",
      "Автобус",
      "Otobüs"
    ),
  }[value] || value;
}

export function passengerServiceLabel(
  value,
  language
) {
  const tx = (ru, uz, tr) =>
    performerText(language, ru, uz, tr);

  return {
    INTERCITY: tx(
      "Межгород",
      "Шаҳарлараро",
      "Şehirlerarası"
    ),
    TRANSFER: tx(
      "Трансфер",
      "Трансфер",
      "Transfer"
    ),
    WEDDING: tx(
      "Свадьба / мероприятие",
      "Тўй / тадбир",
      "Düğün / etkinlik"
    ),
  }[value] || value;
}
